import { render, staticRenderFns } from "./ProposalPolicyHolder.vue?vue&type=template&id=28c7ba8a"
import script from "./ProposalPolicyHolder.vue?vue&type=script&lang=js"
export * from "./ProposalPolicyHolder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports